export enum HotelAvailabilityStatusType {
  AVAILABLE = 'Available',
  ASK_SELL_PLAN = 'AskSellPlan',
  N_A = 'N_A',
  TOO_LATE = 'TooLate',
  NOT_IN_STOCK = 'NotInStock',
  SHORT_ACCOMMODATION = 'ShortAccommodation',
  INDIVISIBLE_NIGHTS = 'IndivisibleNights',
  RESTRICTED = 'Restricted',
  CLOSED_QUOTA = 'ClosedQuota',
  SHORT_ACCOMMODATION_AND_MIN_STAY_TO_ASK_SELL_FALSE = 'ShortAccommodationAndMinStayToAskSellFalse',
  MAX_PEOPLE_EXCEEDED = 'MaxPeopleExceeded',
  ACCOMMODATION_TOO_LONG = 'AccommodationTooLong',
  MIN_STAY_NOT_SATISFIED = 'MinStayNotSatisfied',
}
